import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    REQUEST_ADD_OR_UPDATE_SSH_USER,
    REQUEST_LIST_SSH_USERS,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/sshUserMsgDefinitions";
import { SSHUserCreate } from "userful-chronos-app-common-js/dist/models/config/sshUsers";

export const requestListSSHUsers = (veID: StringID) => {
    const eventBus = getGlobalStates().eventBus;
    if (!eventBus) {
        console.warn("requestListSSHUsers called before eventBus initialization");
        return;
    }
    eventBus.sendMsg(REQUEST_LIST_SSH_USERS, veID);
};

export const requestAddOrUpdateSSHUser = (user: SSHUserCreate) => {
    const eventBus = getGlobalStates().eventBus;
    if (!eventBus) {
        console.warn("requestAddOrUpdateSSHUser called before eventBus initialization");
        return;
    }
    eventBus.sendMsg(REQUEST_ADD_OR_UPDATE_SSH_USER, user);
};
